<template>
    <div class="searchBox">
        <i class="ico ico-icon_52"></i>
        <span class="city">{{paramCity | toSubStr}}</span>
        <i class="ico ico-icon_down"></i>
        <div class="inputBox">
            <i class="ico ico-icon_61"></i>
            <input type="text" v-model="cityName" placeholder="请输入城市名称" @input="onInput" />
            <i class="ico ico-icon_02 close" v-show="cityName !==''" @click="onClearInput"></i>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
export default {
    name: 'selectAddressSearch',
    props: {
        paramCity: {
            type: String,
            default: ''
        }
    },
    components: {
    },
    data () {
        return {
            cityName: '',
        }
    },
    created () {

    },
    activated () {

    },
    watch: {
    },
    mounted () {
    },
    methods: {
        /**
         * 清空文本框
         */
        onClearInput () {
            this.cityName = ''
            this.$emit('onSearch', this.cityName)
        },
        onInput: _.debounce(function () {
            this.$emit('onSearch', this.cityName)
        }, 500),
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables'
.searchBox
    // height 88px
    // width 100%
    padding 14px 30px 14px 30px
    box-sizing border-box
    display flex
    justify-content center
    align-items center
    background #fff
    .ico-icon_52
        margin-right 12px
    .city
        margin-right 22px
    .ico-icon_down
        margin-right 22px
    .inputBox
        flex 1
        position relative
        input
            padding 0 55px 0 60px
            color #333
            width 100%
            box-sizing border-box
            height 60px
            border-radius 30px
            display block
            background #efefef
        .ico-icon_61
            // overflow hidden
            position absolute
            top 10px
            left -1000px
            filter: drop-shadow(1014px 0 0 #999999);
            // background-blend-mode lighten
            // filter: drop-shadow(10px 0 0 #ccc);
            // background-image linear-gradient(#ccc, #ccc)
        .close
            position absolute
            right 10px
            top 8px
            transform scale(0.7)
            transform-origin: center center
    a
        display block
        color #3b3b3b
        font-size 28px
        padding 0 30px
</style>
